module.exports = __webpack_public_path__ + "static/media/Librarian.0a35bdd0.jpg";